
<div class="column-cta-text">

    <!--The content will either be a Quill editor or a customer-site-column-text-->
    <ng-content select=".customer-site-column-text-content"></ng-content>

</div>
<div class="column-cta-button">

    <!--Holding this space for the button-->
    <ng-content select=".customer-site-column-button"></ng-content>

</div>

